import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-border-container',
  templateUrl: './border-container.component.html',
  styleUrls: ['./border-container.component.scss']
})
export class BorderContainerComponent {
  @Input() title: string;


}
